import styled from 'styled-components'

import MenuEntryLink from './MenuEntryLink'
import { mobileMenuLinkStyles } from './styles/mobile-menu'

const StyledMenuEntryLink = styled(MenuEntryLink)`
  ${mobileMenuLinkStyles};
`

export default StyledMenuEntryLink
